import { GET_GIT_REPOS } from "constants/gitRepos";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_GIT_REPOS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
